export const percentage = (total: number, amount: number) => (amount / Math.max(total, 0)) * 100;
